import React from 'react';
import styled from 'styled-components';

import { TextField } from 'components';

const defaultStyle = {
    backgroundColor: 'var(--primary-color)',
    margin: '0.5rem 0 0 0'
}

const Container = styled.div`
    height: 100%;
    background-color: ${props => props.styles.backgroundColor};
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    margin: ${props => props.styles.margin};
    border-style: solid;
    border-width: 2px;
    border-color: ${props => props.error ? 'var(--error-color)' : 'transparent'};
    display: flex;
    flex-direction: column;
    padding: 0.25rem 0.5rem;
`

const Label = styled.div`
    font-size: 0.8rem;
    font-weight: bold;
`

const Error = styled.div`
    font-size: 0.8rem;
    color: var(--error-color);
    margin-left: 0.2rem;
    :before {
        content: '*'
    }
`

const Row = styled.div`
    display: flex;
    align-items: center;
    margin: ${props => props.styles && props.styles.margin};
`

const TextInput = props => {
    const {
        label,
        value,
        onChange,
        onBlur,
        error,
        styles,
        placeholder,
        addDelay,
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)

    return(
        <Container error={error} styles={updatedStyle}>
            {label && 
            <Row styles={{margin: '0 0 0.2rem 0'}}>
                <Label>{label}</Label>
                {error && <Error>{error}</Error>}
            </Row>}
            <TextField value={value} placeholder={placeholder} addDelay={addDelay} type='single' styles={styles}
                onChange={(text) => onChange && onChange(text)} 
                onBlur={(text) => onBlur && onBlur(text)}/>
        </Container>
    )
}

export default TextInput;